export default {
  flexCentered: {
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  baseText: {
    fontFamily: "'Lato', sans-serif",
  },
}
